import Vue from "vue";
import Router from "vue-router";
import Home from "../pages/Home";
import Categories from "../pages/Categories";
import Companies from "../pages/Companies";
import Games from "../pages/Games";
import Sites from "../pages/Sites";
import Users from "../pages/Users";
import SiteUsers from "../pages/SiteUsers";
import SiteGames from "../pages/SiteGames";
import SiteTournaments from "../pages/SiteTournaments";
import Stats from "../pages/Stats";
import Login from "../pages/Login";
import Urls from "../pages/Urls";
import Total from "../pages/Total";
import store from "../store";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      redirect: "/stats",
    },
    {
      path: "/categories",
      name: "Categories",
      component: Categories,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/companies",
      name: "Companies",
      component: Companies,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/games",
      name: "Games",
      component: Games,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/sites",
      name: "Sites",
      component: Sites,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/sites/:id/urls",
      name: "Urls",
      component: Urls,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/sites/:id/games",
      name: "SiteGames",
      component: SiteGames,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/sites/:id/users",
      name: "SiteUsers",
      component: SiteUsers,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/sites/:id/tournaments",
      name: "SiteTournaments",
      component: SiteTournaments,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/users",
      name: "Users",
      component: Users,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/stats",
      name: "Stats",
      component: Stats,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/total",
      name: "Total",
      component: Total,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        requiresAuth: false,
      },
    },
  ],
});

// Add a navigation guard to check for token and validate it
router.beforeEach(async (to, from, next) => {
  const token = sessionStorage.getItem("token");

  // If the route requires authentication
  if (to.meta.requiresAuth) {
    // If token exists
    if (token) {
      next();
    } else {
      // Token doesn't exist, redirect to login or appropriate page
      next("/login");
    }
  } else {
    // Route doesn't require authentication, proceed to the route
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js